module.exports = [
  {
    title: 'Название МО',
    key: 'hospital_name'
  },
  {
    title: 'Регион',
    key: 'region_name'
  },
  {
    title: 'ФИО ',
    key: 'full_name'
  },
  {
    title: 'Учётная запись',
    key: 'username'
  },
  {
    title: 'Активен ',
    key: 'is_active'
  }
]
